import '@outdoorsyco/bonfire/dist/tokens/themes/theme-auto.css';

import Head from 'next/head';
import { useEffect } from 'react';

import { ExternalFonts } from '@/components/common/ExternalFonts';

export const CustomStyles = () => {
  useEffect(() => {
    document.body.classList.add('bf-theme-auto');
    return () => document.body.classList.remove('bf-theme-auto');
  }, []);

  return (
    <>
      <ExternalFonts
        href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;1,400;1,500&family=Public+Sans:ital,wght@0,100..900;1,100..900&display=swap"
        preconnect={['https://fonts.googleapis.com', 'https://fonts.gstatic.com']}
      />

      <Head>
        <style>{`
          /* Renter components & tailwind */
          .bf-theme-auto {
            --renter-primary-font-family: 'Poppins';
          }
        `}</style>
      </Head>
    </>
  );
};
